import React, { useEffect } from 'react';
import { useNotifications } from '../hooks/useNotifications';
import './NotificationSystem.css';

const NotificationSystem = () => {
  const { notifications, hideNotification } = useNotifications();

  return (
    <div className="notification-system">
      {notifications.map(notification => (
        <NotificationToast
          key={notification.id}
          notification={notification}
          onClose={() => hideNotification(notification.id)}
        />
      ))}
    </div>
  );
};

const NotificationToast = ({ notification, onClose }) => {
  useEffect(() => {
    if (notification.duration && notification.duration > 0) {
      const timer = setTimeout(() => {
        onClose();
      }, notification.duration);

      return () => clearTimeout(timer);
    }
  }, [notification.duration, onClose]);

  const getIcon = (type) => {
    switch (type) {
      case 'success': return '✅';
      case 'error': return '❌';
      case 'warning': return '⚠️';
      case 'info': return 'ℹ️';
      default: return 'ℹ️';
    }
  };

  const handleClick = () => {
    if (notification.onClick) {
      notification.onClick();
    }
  };

  return (
    <div
      className={`notification-toast ${notification.type} ${notification.onClick ? 'clickable' : ''}`}
      onClick={handleClick}
    >
      <div className="toast-icon">
        {getIcon(notification.type)}
      </div>
      
      <div className="toast-content">
        {notification.title && (
          <div className="toast-title">{notification.title}</div>
        )}
        <div className="toast-message">{notification.message}</div>
      </div>
      
      <button className="toast-close" onClick={(e) => { e.stopPropagation(); onClose(); }}>
        ✕
      </button>
    </div>
  );
};

export default NotificationSystem;